module.exports = __webpack_public_path__ + "sn.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/4x3/sn.svg
// module id = 811
// module chunks = 0